import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";     // Norsk
import AppEN from "./AppEN"; // Engelsk
import Nav from "./Nav";     // Ny toppmeny med språkvelger
import './index.css';
import reportWebVitals from './reportWebVitals';

function Root() {
  const [language, setLanguage] = useState("no"); // standard språk

  return (
    <>
      {/* Nav får språk og setLanguage som props */}
      <Nav language={language} setLanguage={setLanguage} />

      {/* Rendre App basert på språk */}
      {language === "no" ? <App /> : <AppEN />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
